import * as React from "react";
import RevokeTokenContainer from "../../containers/token/RevokeTokenContainer";
import ViewTokenContainer from "../../containers/token/ViewTokenContainer";
import { Page } from "../../controls/Page";

export default class TokenPage extends React.Component
{
    public render()
    {
        return (
            <section key="dashboard-body" className="dashboard-body">
                <Page title="Your current token">
                <section>
                    <p>The current token associated with your account is:</p>

                    <ViewTokenContainer />

                    <p>Please refer to the <a href="http://docs.gamescorekeeper.com/">API documentation</a> for more information on how to use the token to access the API.</p>
                </section>

                <section>
                    <h2>Generate new token</h2>

                    <p>If you need to revoke access from your current token, you can generate a new one.</p>

                    <p>
                        <span style={{ fontWeight: "bold" }}>Please note</span> that this will invalidate your current token, any systems using it will be denied access to our data until they are supplied with the new token.
                    </p>

                    <RevokeTokenContainer />
                </section>
            </Page>
            </section>
        );
    }
}
